export default "__VITE_ASSET__oONyr_9M__"